import { gql } from '@apollo/client';
import getConfig from 'next/config';
import { setCookie, getTokenFromCookies, getCookie } from '../hooks/useCookie';
import { setCode, setLocalStorage } from '../hooks/useLocalStorage';
import client from '../../util/GraphqlClient';

const { publicRuntimeConfig } = getConfig();

const CROSS_SELL_SCHEMA = `
offerTypes{
    causes
    eligible
    offerType
  }
  serviceGroups{
    causes
    eligible
    serviceGroup
  }
  error
`;

const QUERIES = {
  CHECK_CROSS_SELL_ELIGIBILITY: gql`
    query checkCrossSellEligibility(
        $accountId:Int!,
        $reference:String,
        $parentSubscriptionId:String,
        ) {
            checkCrossSellEligibility(
                accountId: $accountId,
                reference: $reference,
                parentSubscriptionId: $parentSubscriptionId,
            ) {
              ${CROSS_SELL_SCHEMA}
            }
          }
    `,
  CREATE_CROSS_SELL_REQUEST: gql`
    mutation createCrossSellProspect(
      $accountId: String!
      $offerType: String!
      $channel: String!
      $email: String
    ) {
      createCrossSellProspect(
        accountId: $accountId
        offerType: $offerType
        channel: $channel
        email: $email
      )
    }
  `,
};

// to check cross eligibility
export const checkCrossSellEligibility = async ({
  graphql = client.graphql,
  accountId,
  dualplaySubscriptions = '',
  reference = '',
  cookies,
}) => {
  try {
    const token = getTokenFromCookies(cookies);
    const variables = {
      accountId,
      token,
      dualplaySubscriptions,
      reference,
    };
    const { data } = await graphql.query({
      query: QUERIES.CHECK_CROSS_SELL_ELIGIBILITY,
      variables,
    });
    return data.checkCrossSellEligibility;
  } catch (err) {
    throw new Error(err);
  }
};

// to create cross-sell prospect
export const createCrossSellProspect = async ({
  graphql = client.graphql,
  accountId = '',
  offerType = '',
}) => {
  try {
    const variables = {
      accountId,
      offerType,
      channel: getCookie('channel')
        ? getCookie('channel')
        : `${publicRuntimeConfig.NEXT_PUBLIC_CHANNEL}`,
      token: getTokenFromCookies(),
      email: getCookie('email_Address'),
    };
    const { data } = await graphql.mutate({
      mutation: QUERIES.CREATE_CROSS_SELL_REQUEST,
      variables,
    });
    // set recieved referece to localstorage and cookie.
    if (data) {
      setCode('CS');
      setLocalStorage('REF', data.createCrossSellProspect);
      setLocalStorage('PROSPECTUUID', data.createCrossSellProspect);
      setCookie('CS', 'reference', data.createCrossSellProspect);
      setCookie('ION', 'cart_Type', 'CROSS_SELL');
    }
    return data.createCrossSellProspect;
  } catch (err) {
    throw new Error(err);
  }
};
